function normalizeRid(value) {
  if (!value) return null;
  if (value['@rid']) return normalizeRid(value['@rid']);
  return String(value);
}

function existingGroupRidsFromPermissions(permissions) {
  return (permissions || []).map(function (permission) {
    return normalizeRid(permission && (permission.in || permission.group));
  }).filter(Boolean);
}

function availableGroupsForPermission(groups, record) {
  if (record && record.group) return groups || [];

  var existingGroupRids = new Set((record && record.existingGroupRids || []).map(normalizeRid).filter(Boolean));
  if (existingGroupRids.size === 0) return groups || [];

  return (groups || []).filter(function (group) {
    return !existingGroupRids.has(normalizeRid(group));
  });
}

module.exports = {
  availableGroupsForPermission: availableGroupsForPermission,
  existingGroupRidsFromPermissions: existingGroupRidsFromPermissions
};
